import React, { useEffect, useState } from 'react'
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader'
import { getUsuarios, updateCliente } from '../../../services/apis';
import { useNavigate } from 'react-router-dom';
import { Badge, Button, CircularProgress, Dialog, DialogContent, Divider, FormControlLabel, Grid, Switch, TextField, Typography } from '@mui/material';
import { UsuarioCard } from './UsuarioCard';
import { FormCrearUsuario } from './FormCrearUsuario';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { EditarUsuario } from './EditarUsuario';

import ApartmentIcon from '@mui/icons-material/Apartment';
import CancelIcon from '@mui/icons-material/Cancel';
import PersonIcon from '@mui/icons-material/Person';

export const Usuarios = () => {
	const navigate = useNavigate();

	//estados
	const [usuarios, setUsuarios] = useState([]);
	const [usuariosOG, setUsuariosOG] = useState([]);
	const [departamentos, setDepartamentos] = useState([]);
	const [roles, setRoles] = useState([]);
	const [clientes, setClientes] = useState([]);
	const [opciones, setOpciones] = useState([]);
	const [usuariosClientes, setUsuariosClientes] = useState([]);
	const [usuariosClientesAgrupados, setUsuariosClientesAgrupados] = useState([]);
	const [usuariosClientesAgrupadosOG, setUsuariosClientesAgrupadosOG] = useState([]);
	const [opcionesUsuario, setOpcionesUsuario] = useState([]);

	const [loaded, setLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [openCleinte, setOpenCliente] = useState(null);


	const handleClose = () => {
		console.log(openCleinte);

		setOpenCliente(null);
	};


	useEffect(() => {
		cargarUsuarios();
	}, [])

	const cargarUsuarios = async () => {
		try {
			const response = await getUsuarios();
			if (response.success == true) {
				console.log(response.data);

				setUsuarios(response.data.usuarios);
				setUsuariosOG(response.data.usuarios)
				setRoles(response.data.roles);
				setDepartamentos(response.data.departamentos);
				setClientes(response.data.clientes);
				setUsuariosClientes(response.data.usuarios_clientes);
				setUsuariosClientesAgrupados(response.data.usuarios_clientes_agrupados);
				setUsuariosClientesAgrupadosOG(response.data.usuarios_clientes_agrupados);
				setOpciones(response.data.opciones);
				setOpcionesUsuario(response.data.opciones_usuario);
				setLoaded(true);
			} else {

				navigate('/');
			}

		} catch (error) {
			console.error("Error al cargar usuarios:", error);
			navigate('/');
		}
	}
	const handleEvent = (opcionId) => {

		switch (opcionId) {
			case 1:
				setOpen(true);

				// Lógica para la opción 1
				break;

			default:
				console.log("Lógica para una opción desconocida ");

				// Lógica para una opción desconocida
				break;
		}
	}

	const accesoTienda = async (event, idCliente) => {

		console.log(event.target.checked, idCliente);

		let acceso = event.target.checked ? 1 : 0;

		try {
			const response = await updateCliente(idCliente, acceso);
			console.log(response);

			if (response.success) {
				cargarUsuarios();
			}

		} catch (error) {
			console.error("Error:", error);
		}
	}


	const buscarEmpleado = (event) => {

		const searchTerm = event.target.value.toLowerCase();

		if (searchTerm === "") {
			// Si el campo de búsqueda está vacío, puedes restaurar la lista original
			// Por ejemplo:
			setUsuarios(usuariosOG);
			return;
		}

		const resultados = usuarios.filter(usu => {
			return (
				usu.nombre.toLowerCase().includes(searchTerm)
			);
		});


		setUsuarios(resultados);

	}

	const buscarEmpresa = (event) => {
		console.log(event.target.value);

		const searchTerm = event.target.value.toLowerCase();

		if (searchTerm === "") {
			// Si el campo de búsqueda está vacío, puedes restaurar la lista original
			// Por ejemplo:
			setUsuariosClientesAgrupados(usuariosClientesAgrupadosOG);
			return;
		}

		const resultados = usuariosClientesAgrupados.filter(empresa => {
			return (
				empresa.nombre_cliente.toLowerCase().includes(searchTerm)
			);
		});


		setUsuariosClientesAgrupados(resultados);

	}

	return (
		<div className='menu-back fade-in2'>
			<SubHeader titulo={'Usuarios'} />
			{!loaded && (<CircularProgress />)}
			{loaded && (
				<>
					<Grid container direction={'column'} xs={12} >
						<OpcionesMenuFunc opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
					</Grid>

					<Grid container direction="row" padding="1em" justifyContent={'space-around'} alignItems={'start'} gap={4}>

						{/* Contenedor de Empleados */}
						<Grid container xs={11} >
							<Grid
								container
								direction="column"
								justifyContent="start"
								alignItems="start"
								xs={11}
							>
								<Typography variant="h4" gutterBottom>Empleados: {usuarios.length > 0 ? usuarios.length : ''}</Typography>
							</Grid>

							<Grid item xs={12} sx={{ mb: 2 }}>
								<TextField id="standard-basic" label="Buscar empleado..." variant="standard" size="small" name='search' fullWidth onChange={buscarEmpleado} />
							</Grid>
							<Grid container
								direction="row"
								justifyContent="center"
								alignItems="center"
								xs={12}
								gap={2}
							>

								{usuarios.length > 0 ? (
									usuarios.map((usuario, index) => (
										<Grid item xs={12} sm={12} md={10} lg={5.5} xl={1.7} key={usuario.id}>
											<UsuarioCard usuario={usuario} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
										</Grid>
									))
								) : (
									<p>No hay usuarios disponibles</p>
								)}
							</Grid>
						</Grid>

						<Grid item xs={11}>
							<Divider variant="middle" sx={{ minWidth: '100%' }} />
						</Grid>

						{/* Contenedor de Clientes */}
						{usuariosClientes.length > 0 && (
							<Grid container xs={11}>
								<Grid
									container
									direction="column"
									justifyContent="start"
									alignItems="start"
									xs={12}
								>
									<Typography variant="h4" gutterBottom>Clientes: {usuariosClientesAgrupados.length}</Typography>

								</Grid>

								<Grid item xs={12} sx={{ mb: 2 }}>
									<TextField id="standard-basic" label="Buscar empresa..." variant="standard" size="small" name='search' fullWidth onChange={buscarEmpresa} />
								</Grid>
								<Grid
									container
									direction="row"
									justifyContent="center"
									alignItems="center"
									xs={12}
									gap={2}
								>
									{usuariosClientesAgrupados.map((cliente, index) => (
										<>
											<Grid
												container
												direction="column"
												justifyContent="start"
												alignItems="start"
												xs={11.5} sm={12} md={12} lg={5.5} xl={2.7}
												gap={2}
												className="empresa-card fade-in2"
												sx={{ padding: 2, borderRadius: 3, boxShadow: 3, background: "var(--fondoTarjeta)", minHeight: '10vh' }}
											>
												<Grid item xs={12} onClick={() => setOpenCliente(cliente.cliente_id)}>
													<Typography variant="h5" sx={{ p: 1, fontSize: 25, textAlign: 'left' }}>
														<Badge
															badgeContent={cliente.usuarios_clientes.length}
															color="primary"
															anchorOrigin={{
																vertical: 'bottom',
																horizontal: 'left',
															}}
														>
															<ApartmentIcon sx={{ mr: 1, mt: -1.3, fontSize: 50 }} />
														</Badge>
														{cliente.nombre_cliente}
													</Typography>
												</Grid>


												<Divider variant="middle" sx={{ minWidth: '90%' }} />


												{/* <FormControlLabel
													control={
														<Switch
															size="small"
															checked={cliente.acceso_tienda == 1 ? true : false}
															onChange={(event) => accesoTienda(event, cliente.cliente_id)} />
													}
													label="Acceso a Tienda"
												/> */}

											</Grid>


											<Dialog
												fullWidth
												maxWidth="xl"
												open={openCleinte === cliente.cliente_id === true}
												onClose={handleClose}
											>
												<DialogContent className='App' style={{ minHeight: '80vh' }}>
													<Grid
														container
														direction="row"
														justifyContent="space-between"
														alignItems="center"
														xs={12}
													>
														<Typography variant="h4">{cliente.nombre_cliente}</Typography>

														<Grid
															container
															direction="row"
															justifyContent="center"
															alignItems="center"
															xs={'auto'}
														>
															<FormControlLabel
																control={
																	<Switch
																		size="small"
																		checked={cliente.acceso_tienda == 1 ? true : false}
																		onChange={(event) => accesoTienda(event, cliente.cliente_id)} />
																}
																label="Acceso a Tienda"
															/>


															<CancelIcon fontSize='medium' className='pointer' onClick={handleClose} />
														</Grid>

													</Grid>

													<Divider sx={{ mt: 1, mb: 3 }}></Divider>
													<Grid
														container
														direction="row"
														justifyContent="center"
														alignItems="center"
														xs={12}
														gap={2}
													>
														{cliente.usuarios_clientes.map((info, index) => (
															<Grid
																container
																direction="column"
																justifyContent="center"
																alignItems="center"
																xs={11.5} md={2.5}
															>
																<UsuarioCard usuario={info} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
															</Grid>
														))}

													</Grid>

												</DialogContent>
											</Dialog>

										</>

									))}
								</Grid>


								{/* <Grid container xs={12} rowSpacing={3} columnSpacing={1} direction={'row'} justifyContent={"start"}>

									{usuariosClientes.length > 0 ? (
										usuariosClientes.map((usuario,) => (
											<Grid item xs={12} sm={12} md={8} lg={6} xl={4} key={usuario.id}>
												<UsuarioCard usuario={usuario} opciones={opcionesUsuario} cargarUsuarios={cargarUsuarios} roles={roles} clientes={clientes} departamentos={departamentos} />
											</Grid>
										))
									) : (
										<p>No hay usuarios de clientes disponibles</p>
									)}
								</Grid> */}
							</Grid>
						)}
					</Grid>

					{/* Formulario de creación de usuario */}
					{open && (
						<FormCrearUsuario
							open={open}
							setOpen={setOpen}
							cargarUsuarios={cargarUsuarios}
							departamentos={departamentos}
							roles={roles}
							clientes={clientes}
						/>
					)}
				</>
			)}
		</div>
	);
};